import { GetRoomsByPropertyIdRequest } from '@/api/generated/fetch-client/apis/property-api';
import { listingsPageSize } from '@/config/consts';
import { WithRepository } from '@/types/typings';
import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';

import { AccommodationRepository } from '../repository/accommodation-repository';
import { useAccommodationRepository } from '../repository/use-accommodation-repository';

export function useGetRoomsByPropertyId(params: GetRoomsByPropertyIdRequest) {
  const repository = useAccommodationRepository();
  const query = useInfiniteQuery(
    useGetRoomsByPropertyId.options({ ...params, repository }),
  );
  return query;
}

useGetRoomsByPropertyId.baseKey = 'Rooms';

useGetRoomsByPropertyId.keys = (params: GetRoomsByPropertyIdRequest) =>
  [useGetRoomsByPropertyId.baseKey, { ...params }] as const;

useGetRoomsByPropertyId.options = ({
  repository,
  ...params
}: WithRepository<GetRoomsByPropertyIdRequest, AccommodationRepository>) =>
  infiniteQueryOptions({
    queryKey: [...useGetRoomsByPropertyId.keys(params), 'ignoreLoading'],
    queryFn: ({ signal, pageParam }) =>
      repository.getRoomsByPropertyId({
        ...params,
        page: pageParam,
        size: listingsPageSize,
        signal,
      }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, _, lastPageParam) =>
      lastPage.length === listingsPageSize ? lastPageParam + 1 : undefined,
    select: (result) => result.pages.flat(),
    staleTime: 0,
  });
